module.exports = __webpack_public_path__ + "static/media/editor-open.40a11d03.svg";